import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';

export const getIsEditable = createSelector(
  selectDecoratorsState,
  ({ isEditable }): boolean => isEditable
);
